import { createContext, useContext, useMemo } from 'react';
import useServiceDataCallbacks from '../model/hooks/useServiceDataCallbacks';
import useShopCallbacks from '../model/hooks/useShopCallbacks';
import useFavoritesCallbacks from '../model/hooks/useFavoritesCallbacks';
import useQuizCallbacks from '../model/hooks/useQuizCallbacks';
import useRatingCallbacks from '../model/hooks/useRatingCallbacks';
import useQuestsCallbacks from '../model/hooks/useQuestsCallbacks';
import useUserCallbacks from '../model/hooks/useUserCallbacks';
import useGameCallbacks from '../model/hooks/useGameCallbacks';
import useBeautyCallbacks from '../model/hooks/useBeautyCallbacks';
import useElfCallbacks from '../model/hooks/useElfCallbacks';
import useProductsCallbacks from '../model/hooks/useProductsCallbacks';
import useTgCallbacks from '../model/hooks/useTgCallbacks';
import useWishCallbacks from '../model/hooks/useWishCallbacks';
import usePremiumCallbacks from '../model/hooks/usePremiumCallbacks';
import useGradesCallbacks from '../model/hooks/useGradesCallbacks';
import useChallengesCallbacks from '../model/hooks/useChallengesCallbacks';
import usePrizeCallbacks from '../model/hooks/usePrizeCallbacks';
import useOtherCallbacks from '../model/hooks/useOtherCallbacks';
import useGuessPriceCallbacks from '../model/hooks/useGuessPriceCallbacks';
import useYearStatCallbacks from '../model/hooks/useYearStatCallbacks';
import useDrawingResultCallbacks from '../model/hooks/useDrawingResultCallbacks';
import useOnboardingCallbacks from '../model/hooks/useOnboardingCallbacks';
import useConverterCallback from '../model/hooks/useConverterCallback';
import usePrizesCallbacks from '../model/hooks/usePrizesCallbacks';

const ApplicationCallbacksContext = createContext({});

export const useApplicationCallbacks = () => useContext(ApplicationCallbacksContext);

/** @returns {ApplicationCallbacks}*/
export default function ApplicationCallbacksProvider({ children }) {
  const serviceDataCallbacks = useServiceDataCallbacks();
  const shopCallbacks = useShopCallbacks();
  const favoritesCallbacks = useFavoritesCallbacks();
  const quizCallbacks = useQuizCallbacks();
  const ratingCallbacks = useRatingCallbacks();
  const questsCallbacks = useQuestsCallbacks();
  const userCallbacks = useUserCallbacks();
  const gameCallbacks = useGameCallbacks();
  const beautyCallbacks = useBeautyCallbacks();
  const elfCallbacks = useElfCallbacks();
  const productsCallbacks = useProductsCallbacks();
  const tgCallbacks = useTgCallbacks();
  const wishCallbacks = useWishCallbacks();
  const premiumCallbacks = usePremiumCallbacks();
  const gradesCallbacks = useGradesCallbacks();
  const challengesCallbacks = useChallengesCallbacks();
  const prizeCallbacks = usePrizeCallbacks();
  const otherCallbacks = useOtherCallbacks();
  const guessPriceCallbacks = useGuessPriceCallbacks();
  const yearStatCallbacks = useYearStatCallbacks();
  const drawingResultCallbacks = useDrawingResultCallbacks();
  const onboardingCallbacks = useOnboardingCallbacks();
  const converterCallbacks = useConverterCallback();
  const prizesCallbacks = usePrizesCallbacks();

  const callbacks = useMemo(
    () => ({
      ...serviceDataCallbacks,
      ...shopCallbacks,
      ...favoritesCallbacks,
      ...quizCallbacks,
      ...ratingCallbacks,
      ...questsCallbacks,
      ...userCallbacks,
      ...gameCallbacks,
      ...beautyCallbacks,
      ...elfCallbacks,
      ...productsCallbacks,
      ...tgCallbacks,
      ...wishCallbacks,
      ...premiumCallbacks,
      ...gradesCallbacks,
      ...challengesCallbacks,
      ...prizeCallbacks,
      ...otherCallbacks,
      ...guessPriceCallbacks,
      ...yearStatCallbacks,
      ...drawingResultCallbacks,
      ...onboardingCallbacks,
      ...converterCallbacks,
      ...prizesCallbacks,
    }),
    [],
  );

  return <ApplicationCallbacksContext.Provider value={callbacks}>{children}</ApplicationCallbacksContext.Provider>;
}
